import React from 'react';
import PropTypes from 'prop-types';

const Edit = ({ color = '#8C949C' }) => (
    <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <path
                d="M2.28169672,2.12363735 L1.87929342,2.12363735 C2.08596306,2.12363735 2.25932624,2.26140011 2.30635536,2.44705488 L2.31707915,2.58770595 C2.29653166,2.80383329 2.10837315,2.97309229 1.87929342,2.97309229 C1.39367308,2.97309229 1,2.59277836 1,2.12363735 C1,1.65449634 1.39367308,1.27418241 1.87929342,1.27418241 L4.77311022,1.27418241 C4.8063351,0.563052296 5.42492528,0 6.17778007,0 L9.39920459,0 C10.1520594,0 10.7706496,0.563052296 10.8038744,1.27418241 L14.1207066,1.27418241 C14.6063269,1.27418241 15,1.65449634 15,2.12363735 C15,2.59277836 14.6063269,2.97309229 14.1207066,2.97309229 L13.3866816,2.97309229 L12.4910962,14.7144221 C12.4029727,15.4406777 11.8370479,15.9991493 11.088012,16 L4.64464591,15.9999997 C3.88931853,15.9991415 3.3366749,15.4644737 3.24027667,14.6961728 L2.34646253,2.97309229 L1.87929342,2.97309229 C1.63648325,2.97309229 1.43964671,2.78293533 1.43964671,2.54836482 C1.43964671,2.31379432 1.63648325,2.12363735 1.87929342,2.12363735 L2.28169672,2.12363735 Z M13.4514749,2.12363735 L14.1207066,2.12363735 L13.4514749,2.12363735 Z M5.65505352,1.27418241 L9.92193114,1.27418241 C9.88976791,1.03674879 9.67003296,0.849454941 9.39920459,0.849454941 L6.17778007,0.849454941 C5.9069517,0.849454941 5.68721675,1.03674879 5.65505352,1.27418241 Z M4.22039394,4.46663894 L4.68045022,13.3555278 L5.59941478,13.3111388 L5.13935851,4.42224995 L4.22039394,4.46663894 Z M10.6611818,4.42224995 L10.2011255,13.3111388 L11.1200901,13.3555278 L11.5801464,4.46663894 L10.6611818,4.42224995 Z M7.48239241,4.21052632 L7.48239241,13.3157895 L8.48239241,13.3157895 L8.48239241,4.21052632 L7.48239241,4.21052632 Z"
                id="delete-path-1"
            />
        </defs>
        <g id="btn_delete_16px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Fill/Primary/Default">
                <rect
                    id="Rectangle"
                    fill="#D8D8D8"
                    fillRule="nonzero"
                    opacity="0"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                />
                <mask id="mask-2" fill="white">
                    <use xlinkHref="#delete-path-1" />
                </mask>
                <use
                    id="Combined-Shape"
                    fill={color}
                    fillRule="nonzero"
                    xlinkHref="#delete-path-1"
                    className="icon-color"
                />
            </g>
        </g>
    </svg>
);

Edit.propTypes = {
    color: PropTypes.string,
};

export default Edit;
